import Breadcrumb from '../Components/Breadcrumb';
import SEO from '../Components/SEO';
import { useState } from 'react';
import emailjs from '@emailjs/browser';

export default function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [status, setStatus] = useState(null);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');
        try {
            // Replace with your EmailJS service/template IDs
            await emailjs.send(
                'YOUR_SERVICE_ID',
                'YOUR_TEMPLATE_ID',
                {
                    from_name: formData.name,
                    from_email: formData.email,
                    subject: formData.subject,
                    message: formData.message,
                },
                'YOUR_PUBLIC_KEY'
            );
            setStatus('success');
            setFormData({ name: '', email: '', subject: '', message: '' });
        } catch (err) {
            setStatus('error');
        }
    };

    return (
        <div>
            <SEO
                title='Contact | English Exam Exercises'
                description='Get in touch with English Exam Exercises for questions, feedback, or support.'
                name='English Exam Exercises'
                type='article' />
            <Breadcrumb />

            <div className="grammar-container">
                <div className="exercises-container div1">
                    <div className='homebodytext'>
                        <img src="/Images/contact.webp" alt="Contact Us" />
                        <section>
                            <h2>Contact Us</h2>
                            <p>Have a question, suggestion, or found an error in our exercises? We'd love to hear from you.</p>

                            <div className="contact-info" style={{ marginBottom: '30px' }}>
                                <h3>Other Ways to Reach Us</h3>
                                <ul>
                                    <li><strong>Email:</strong> <a href="mailto:info@englishexamexercises.com">info@englishexamexercises.com</a></li>
                                    <li><strong>Response time:</strong> Usually within 48 hours</li>
                                </ul>
                            </div>

                            <form onSubmit={handleSubmit} style={{ maxWidth: '600px' }}>
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Name *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Email *</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="subject" className="form-label">Subject *</label>
                                    <select
                                        className="form-select"
                                        id="subject"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select a topic</option>
                                        <option value="general">General Inquiry</option>
                                        <option value="content">Content Error / Suggestion</option>
                                        <option value="technical">Technical Issue</option>
                                        <option value="privacy">Privacy / Data Request</option>
                                        <option value="advertising">Advertising / Partnership</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="message" className="form-label">Message *</label>
                                    <textarea
                                        className="form-control"
                                        id="message"
                                        name="message"
                                        rows={5}
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <button type="submit" className="btn btn-primary" disabled={status === 'sending'}>
                                    {status === 'sending' ? 'Sending...' : 'Send Message'}
                                </button>

                                {status === 'success' && (
                                    <div className="alert alert-success mt-3">Message sent successfully! We'll get back to you soon.</div>
                                )}
                                {status === 'error' && (
                                    <div className="alert alert-danger mt-3">Failed to send. Please try again or email us directly.</div>
                                )}
                            </form>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}